import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x20900000 {
  parentID: number;
}

export function Command0x20900000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    parentID: 0,
  };

  const [fields, setFields] = React.useState<Form0x20900000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x20900000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.parentID) {
      params.parentID = 0;
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          id="parentID"
          label="ID запроса"
          margin="dense"
          fullWidth
          value={fields.parentID}
          onChange={handleChangeField("parentID")}
        />
      </FormControl>
    </>
  );
}
